import { Action, isRejectedWithValue } from "@reduxjs/toolkit";
import { isRecord } from "@timeedit/registration-shared";

/**
 * Helper to identify the best label for the error message inside the
 * RTK Query error middleware, since meta.arg is of unknown type.
 */
export function identifyRTKErrorLocation(action: Action): unknown {
  if (!isRejectedWithValue(action)) {
    return action.type;
  }

  if (!isRecord(action.meta.arg)) {
    return action.type;
  }

  if ("endpointName" in action.meta.arg) {
    return action.meta.arg.endpointName;
  }

  return "Unknown location";
}
